import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const InnovaCrysta = () => {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Innova Crysta Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>Book Innova Crysta with eTravo</h1>

        <p style={styles.paragraph}>
          The Toyota Innova Crysta is synonymous with luxury, space, and performance. At <strong>eTravo</strong>,
          we provide premium Innova Crysta rentals for families, business travelers, and VIP clients looking
          for a smooth and elegant travel experience.
        </p>

        <h2 style={styles.subHeader}>Why Choose Innova Crysta?</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Powerful 2.4L / 2.8L diesel engine</li>
          <li style={styles.listItem}>Luxurious captain or bench seats (6/7-seater)</li>
          <li style={styles.listItem}>Dual-zone automatic climate control</li>
          <li style={styles.listItem}>Touchscreen infotainment with Bluetooth & navigation</li>
          <li style={styles.listItem}>Rear AC vents and reading lights</li>
          <li style={styles.listItem}>Spacious legroom & boot space</li>
        </ul>

        <h2 style={styles.subHeader}>Best For:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Airport Transfers</li>
          <li style={styles.listItem}>Business Meetings</li>
          <li style={styles.listItem}>Luxury Family Trips</li>
          <li style={styles.listItem}>Outstation Travel</li>
          <li style={styles.listItem}>Corporate Delegates</li>
        </ul>

        <h2 style={styles.subHeader}>Why Rent from eTravo?</h2>
        <p style={styles.paragraph}>
          With a reputation for quality service and transparent pricing, <strong>eTravo</strong> offers 
          unmatched reliability in Innova Crysta rentals. All our vehicles are well-maintained, sanitized, 
          and driven by professionally trained chauffeurs who value your time and safety.
        </p>

        <p style={styles.paragraph}>
          We offer 24x7 customer support, instant confirmations, and flexible pickup/drop options, making us 
          the preferred choice for travelers across India.
        </p>

      

        <h2 style={styles.subHeader}>Experience the eTravo Standard</h2>
        <p style={styles.paragraph}>
          Whether you're booking for business or leisure, enjoy the comfort of Innova Crysta with eTravo's 
          top-rated service. Book now for a premium ride that matches your expectations.
        </p>
      </div>
    </>
  );
};

export default InnovaCrysta;
